
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3catinfo/3catinfo-verifica",
      function () {
        return require("private-next-pages/3catinfo/3catinfo-verifica/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3catinfo/3catinfo-verifica"])
      });
    }
  